import PropTypes from 'prop-types'
import { LeafFill } from 'react-bootstrap-icons'

const sizeClasses = {
  sm: 'w-10 h-10',
  md: 'w-16 h-16',
  lg: 'w-24 h-24'
}

const AppBrandIcon = ({
  size = 'md',
  className = ''
}) => {
  return (
    <div
      aria-label='Green Farm Aid'
      className={`${sizeClasses[size] || sizeClasses.md} rounded-full bg-green-50 text-greenPrimary border border-green-100 flex items-center justify-center shadow-sm ${className}`}
      role='img'
    >
      <LeafFill aria-hidden='true' className='w-3/5 h-3/5' />
    </div>
  )
}

AppBrandIcon.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string
}

export default AppBrandIcon
